export default {
  arabic: {
    readingTime: 'وقت القراءة: {{ time }}} دقيقة.',
  },
  english: {
    readingTime: 'Read time: {{ time }} min.',
  },
  french: {
    readingTime: 'Temps de lecture : {{ time }} min.',
  },
  hebrew: {
    readingTime: 'זמן קריאה: {{ time }} דקות.',
  },
  persian: {
    readingTime: 'زمان خواندن: {{ time }} دقیقه',
  },
}
